<!-- =========================================================================================
    File Name: VerticalNavMenuItem.vue
    Description: Vertical NavMenu item component. Extends vuesax framework's 'vs-sidebar-item' component
    Component Name: VerticalNavMenuItem
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div
    :id="'item-header-id-'+mail_server+'-'+id"
    v-if="canSee"
    class="vs-sidebar--item"
    :class="[
      {'vs-sidebar-item-active'            : activeLink},
      {'disabled-item pointer-events-none' : isDisabled}
    ]"
    @dragover="
      canEdit &&
        $route.fullPath.includes(to.split('/')[2]) &&
        onDragOver($event, mail_server, id)
    "
    @drop="
      canEdit &&
        $route.fullPath.includes(to.split('/')[2]) &&
        onDrop($event, mail_server, id)
    "
    @dragleave="
      canEdit &&
        $route.fullPath.includes(to.split('/')[2]) &&
        onDragLeave(mail_server, id)
    "
  >
    <div
      :class="[
        { 'router-link-active': activeLink },
        { 'auto-padding-router-link group-header flex items-center': canEdit },
      ]"
    >
      <feather-icon
        v-if="canEdit && id != 0"
        :class="{ 'w-3 h-3 ml-5 mr-5 ': iconSmall }"
        icon="EditIcon"
        @click="activePopup('EDIT', mail_server, id, name , to )"
      />
      <feather-icon
        v-if="canEdit"
        :class="{ 'w-3 h-3 mr-0': iconSmall }"
        icon="PlusIcon"
        @click="activePopup('ADD', mail_server, id)"
      />
      <router-link
        :id="`router-link-item-${this.to}`"
        tabindex="-1"
        v-if="to"
        exact
        :to="toPath"
        :target="target"
      >
        <vs-icon v-if="!featherIcon" :icon-pack="iconPack" :icon="icon" />
        <feather-icon
          v-if="
            ($route.fullPath.includes('admin') && icon) ||
            (icon != 'MailIcon' && name != '受信')
          "
          :class="{ 'w-3 h-3': iconSmall }"
          :icon="icon"
        />
        <slot />
      </router-link>

      <a v-else :target="target" :href="href" tabindex="-1">
        <vs-icon v-if="!featherIcon" :icon-pack="iconPack" :icon="icon" />
        <feather-icon v-else :class="{'w-3 h-3': iconSmall}" :icon="icon" />
        <slot />
      </a>
  </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: 'v-nav-menu-item',
  props: {
    icon        : { type: String,                 default: ''               },
    iconSmall   : { type: Boolean,                default: false            },
    iconPack    : { type: String,                 default: 'material-icons' },
    href        : { type: [String, null],         default: '#'              },
    to          : { type: [String, Object, null], default: null             },
    slug        : { type: String,                 default: null             },
    index       : { type: [String, Number],       default: null             },
    featherIcon : { type: Boolean,                default: true             },
    target      : { type: String,                 default: '_self'          },
    isDisabled  : { type: Boolean,                default: false            },
    canEdit     : { type: Boolean,                default: false            },
    name        : { type: String,                 default: ""               },
    id          : { type: Number,                 default: 0                },
    mail_server : { type: String,                 default: ""               },
    parent      : { type: Number,                 default: null             },
  },
  computed: {
    ...mapGetters({
      reload: "reload",
    }),
    canSee() {
      this.$acl.check(this.$store.state.AppActiveUser.userRole)
      return this.to ? this.$acl.check(this.$router.match(this.to).meta.rule) : true
    },
    activeLink () {
      let active = !!((this.$route.path == this.to || this.$route.meta.parent === this.slug) && this.to);
      return active;
    },
    toPath() {
      let queryString = this.to;
      if (this.$route.query.mode === 'shachihatadesk') {
        queryString += '?mode=shachihatadesk';
        if (this.$route.query.urlorigin) {
          queryString += `&urlorigin=${this.$route.query.urlorigin}`;
        }
      }
      return queryString;
    }
  },
  methods: {
    ...mapActions({
      togglePopup: "togglePopup",
      moveToFolder: "mailFolder/moveToFolder",
      getListMailBox: "receiveMail/getListMailBox",
    }),
    activePopup(type, mail_server, id, name = "", url = "") {
      this.togglePopup({ type, data: { mail_server, id, name, url } });
    },

    onDragOver(event, mail_server, id) {
      let hover = document.getElementById("item-header-id-"+mail_server+'-'+id).firstElementChild;
      hover.classList.add("drag-hover");
      var dragSupported = event.dataTransfer.length;
      if (dragSupported) {
        event.dataTransfer.dropEffect = "move";
      }
      event.preventDefault();
    },
    async onDrop(event, mail_server, id) {
      const jsonData = event.dataTransfer.getData("application/json") ? JSON.parse(event.dataTransfer.getData("application/json")) : null;
      if (jsonData) {
          let data = {
              mailBox: this.$route.params.email,
              mail_id: jsonData.id,
              folder_id: id,
          };
          //Move to folder
          await this.moveToFolder(data);
      }
      let unHover = document.getElementById("item-header-id-"+mail_server+'-'+id).firstElementChild;
      unHover.classList.remove("drag-hover");
      await this.getListMailBox();
      let folder = null;
      if (this.$route.fullPath.includes("folder") == true) {
        folder =
          this.$route.fullPath.split("/")[
            this.$route.fullPath.split("/").length - 1
          ];
      }
      await this.reload(false, false, this.$route.params.email, folder);
    },
    onDragLeave(mail_server, id){
      let unHover = document.getElementById("item-header-id-"+mail_server+'-'+id).firstElementChild;
      unHover.classList.remove("drag-hover");
    },
  },
};
</script>

<style lang="scss">
.con-vs-chip {
  .v-nav-menu .vs-sidebar--item a > & {
    left: 8px;
  }
}
</style>



